import React, { useEffect, useRef } from "react";
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import OSM from "ol/source/OSM";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { fromLonLat } from "ol/proj";
import { Style, Icon } from "ol/style";
import location from "@/assets/images/about/location.png";
import { useMemo } from "react";
    

const Location = () => {
  const mapRef = useRef(null);
  const vectorSource = new VectorSource();
  const vectorLayer = new VectorLayer({
    source: vectorSource,
  });
  const lang = useMemo(() => {
    return localStorage.getItem("lang") || "en-US";
  }, []);
  useEffect(() => {
    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new XYZ({
            url: "http://t0.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=8c471ad83d563e443d9a630de25f23a0",
          }),
        }),
        // vectorLayer,
      ],
      view: new View({
        center: fromLonLat([0, 0]),
        zoom: 2,
        maxZoom:18
      }),
    });
    const getCurrentLocation = (e) => {
      const point = new Point(fromLonLat(e));
      const feature = new Feature({
        geometry: point,
      });
      // 创建自定义图标样式
      const customIconStyle = new Style({
        image: new Icon({
          scale: 0.5,
          src: location, // 替换为你的自定义图标链接
        }),
      });
      feature.setStyle(customIconStyle);
      vectorSource.addFeature(feature);
      map.addLayer(vectorLayer)
      map.getView().setCenter(point.getCoordinates());
      map.getView().setZoom(17);
    };
    if (lang === "zh-CN") {
      map.addLayer(
        new TileLayer({
            source: new XYZ({
              url: "http://t0.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=8c471ad83d563e443d9a630de25f23a0",
            }),
        })
      );
      getCurrentLocation([114.35655, 30.52771]);
    } else {
      map.addLayer(
        new TileLayer({
          source: new XYZ({
            url: "http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=en&size=1&style=7&x={x}&y={y}&z={z}"
          }),
        })
      );
      getCurrentLocation([114.362065700955,30.525369194879]);
    }


   
    return () => {
      map.setTarget(null);
    };
  }, [lang]);
  return (
    <div>
      <div ref={mapRef} style={{ width: "100%", height: "500px" }} />
    </div>
  );
};

export default Location;
